var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScanner = function SvgScanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.75 7A2.25 2.25 0 0 1 7 4.75h10A2.25 2.25 0 0 1 19.25 7v2a.75.75 0 0 1-1.5 0V7a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75v2a.75.75 0 0 1-1.5 0V7Zm0 10A2.25 2.25 0 0 0 7 19.25h10A2.25 2.25 0 0 0 19.25 17v-1.5a.75.75 0 0 0-1.5 0V17a.75.75 0 0 1-.75.75H7a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 0-1.5 0V17Zm-.5-5.5a.75.75 0 0 0 0 1.5h15.5a.75.75 0 0 0 0-1.5H4.25Z",
    clipRule: "evenodd"
  })));
};
export default SvgScanner;